import { useEffect } from 'react';
import BetaContext from '../../context/BetaContext';
import LandingPage from './LandingPage';

/**
 * Route /preview — la vitrine telle qu'elle sera APRES la beta.
 *
 * Elle surcharge le BetaContext avec betaEnabled: false, ce qui redonne
 * la navbar complete, les tarifs et les pages marketing, sans dependre
 * du parametre BETA_ENABLED en base.
 *
 * Elle n'est atteignable que par son URL (aucun lien depuis le site) et
 * est explicitement desindexee.
 *
 * Le contenu de cette page evoluera : c'est ici qu'on remplacera LandingPage
 * par la future vitrine enrichie.
 */

const PREVIEW_BETA_STATE = {
    betaEnabled: false,
    betaLoading: false,
    betaConfig: null
};

const useNoIndex = () => {
    useEffect(() => {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.appendChild(meta);
        return () => {
            if (meta.parentNode) {
                meta.parentNode.removeChild(meta);
            }
        };
    }, []);
};

const PreviewPage = ({ onLogin }) => {
    useNoIndex();

    return (
        <BetaContext.Provider value={PREVIEW_BETA_STATE}>
            <LandingPage onLogin={onLogin} />
        </BetaContext.Provider>
    );
};

export default PreviewPage;
